import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import BrandButton from 'components/BrandButton';
import CmsBlock from 'components/CmsBlock';
import { getSearchUrl } from 'helpers/namedUrls';
import cn from './styles.local.less';

export default class NoResultsBlock extends PureComponent {
  static propTypes = {
    cmsHtml: PropTypes.string.isRequired,
    isDislike: PropTypes.bool.isRequired,
  };

  render() {
    const { cmsHtml, isDislike } = this.props;

    return (
      <div className={cn.root}>
        <CmsBlock content={cmsHtml} />
        <BrandButton href={getSearchUrl()} bsStyle="primary" bsSize="large">
          {isDislike
            ? __('favorites.overview.dislikeNoResults.searchBtn')
            : __('favorites.overview.noresults.searchBtn')}
        </BrandButton>
      </div>
    );
  }
}
